module.exports = __webpack_public_path__ + "static/media/partner.3ac5a69c.png";